/*
Usage:
    Subscribe:
        viiEventDispatcher.subscribe({
            type: 'GoogleTagManager',
            dataLayerName: 'dataLayer',
            containerId: '[AnalyticsTrackingId]'
        });
        viiEventDispatcher.subscribe({
            type: 'GoogleAnalytics',
            dataLayerName: 'dataLayer',
            containerId: '[AnalyticsTrackingId]'
        });
        viiEventDispatcher.subscribe({
            type: 'Console'
        });
    
    Push Events:

        viiEventDispatcher.push({
            event: 'trackPageView',
            pageName: '[PageName]'
        })


*/


var viiEventDispatcher = {
    
    options: {
        subscribers: []
    },

    subscribe: function(subscriber) {
        this.options.subscribers.push(subscriber);
        this.subscriberInit[subscriber.type](subscriber);
    },

    push: function(eventData) {
        for(let i=0;i<this.options.subscribers.length; i++){
            this.processSubcriberPush(this.options.subscribers[i], eventData);
        }
    },
    
    processSubcriberPush: function(subscriber, eventData) {
        return this.subscriberPush[subscriber.type](subscriber, eventData);
    },

    subscriberPush: {
        'GoogleTagManager': function(subscriber, eventData) {
            window[subscriber.dataLayerName].push(eventData);
        },
        'GA4': function(subscriber, eventData) {
            if (eventData.ecommerce)
                gtag('event', eventData.event, eventData.ecommerce)
        },
        'Console': function(subscriber, eventData) {
            console.log(eventData);
        }
    },

    subscriberInit: {
        'GoogleTagManager': function(subscriber) {
            (function(w, d, s, l, i) {
                w[l] = w[l] || [];
                w[l].push({
                    'gtm.start':
                        new Date().getTime(),
                    event: 'gtm.js'
                });
                var f = d.getElementsByTagName(s)[0],
                    j = d.createElement(s),
                    dl = l != 'dataLayer' ? '&l=' + l : '';
                j.async = true;
                j.src =
                    'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                f.parentNode.insertBefore(j, f);
            })(window, document, 'script', subscriber.dataLayerName, subscriber.containerId);
        },
        'GA4': function(subscriber) {
            //Use gtag snippet provided by console instead.
        },

        'Console': function(subscriber) {}
    }
};
window.viiEventDispatcher = viiEventDispatcher;
//export { viiEventDispatcher };